"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Loading2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Loading"));
var _context = require("../../../../services/auth/context");
var _CustomSocialButton = _interopRequireDefault(require("./CustomSocialButton"));
var _apiV = require("../../../../services/auth/apiV2");
var _usePublishLoginStarted = _interopRequireDefault(require("../../consts/events/business/usePublishLoginStarted"));
var _jsxRuntime = require("react/jsx-runtime");
var _Loading;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SocialsLogin = () => {
  const loading = (0, _context.useIsUserLoading)();
  const publishLoginStarted = (0, _usePublishLoginStarted.default)();
  if (loading) {
    return _Loading || (_Loading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading2.default, {
      loading: true,
      type: "boxLoader"
    }));
  }
  async function handleSocialLoginClick(e) {
    const provider = e.currentTarget.id;
    publishLoginStarted(provider);
    const redirectPath = encodeURIComponent(window.location.pathname + window.location.search);
    const stateParam = `${provider}:redirectPath=${redirectPath}`;
    await (0, _apiV.handleSocialLogin)(provider, stateParam);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    spacing: "200",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
      spacing: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomSocialButton.default, {
        id: "google",
        dataTest: "MagicLogin-LoginViaGoogle",
        buttonType: "google",
        onClick: handleSocialLoginClick
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
      spacing: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomSocialButton.default, {
        id: "facebook",
        dataTest: "MagicLogin-LoginViaFacebook",
        buttonType: "facebook",
        onClick: handleSocialLoginClick
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
      spacing: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomSocialButton.default, {
        id: "apple",
        dataTest: "MagicLogin-LoginViaApple",
        buttonType: "apple",
        onClick: handleSocialLoginClick
      })
    })]
  });
};
var _default = exports.default = SocialsLogin;